import React, { useRef, useEffect, useState } from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { transparentize } from 'polished';
import tw from 'twin.macro';
import { SiteLink } from '../styles/buttons';
import { Wrapper } from '../styles/mainStyles';

const Spacer = styled.div`
  ${tw`w-full pt-10 sm:pt-20`}
`;

const HeaderContainer = styled.div`
  ${tw`absolute z-50 w-full top-0`}
`;

const HeaderContent = styled.header`
  top: ${(p) => (p.sticky ? '0' : '')};
  width: 100%;
  position: ${(p) => (p.sticky ? 'fixed' : 'relative')};
  background-color: ${(p) => (p.transparent ? 'transparent'
    : transparentize(0.15, p.theme.color.background))};
`;

export const SiteLogo = styled.div`
  ${tw`
    flex m-0 flex-auto self-stretch p-0
  `}
`;

export const HeaderWrapper = styled(Wrapper)`
  ${tw`
    flex self-stretch justify-between items-center h-full flex-row px-12 sm:px-0
  `}
  min-height: 2.5rem;
`;

const HeaderSection = ({ siteTitle, headerOptions, children }) => {
  const [sticky, setSticky] = useState(false);
  const spacerEl = useRef(null);
  const handleScroll = () => {
    const { offsetHeight } = spacerEl.current;
    if (window.pageYOffset >= offsetHeight) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };
  useEffect(() => {
    if (headerOptions.sticky) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  });
  return (
    <HeaderContainer id="header">
      <Spacer ref={spacerEl} />
      <HeaderContent sticky={sticky} transparent={headerOptions.transparent}>
        <HeaderWrapper>
          <SiteLogo>
            <SiteLink
              data-a11y="false"
              aria-label="Go to main page"
              to="/"
            >
              <Img
                fixed={headerOptions.logo.childImageSharp.fixed}
                alt={siteTitle}
              />
            </SiteLink>
          </SiteLogo>
          {children}
        </HeaderWrapper>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default HeaderSection;
